import { Grid } from "@mui/material";
import { MultiWithModal } from "components/FormControls/MultiWithModal";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { TextInput } from "components/FormControls/TextInput";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import _ from "lodash";
import { VariableGroupsDropdown } from "./VariableGroupsDropdown/VariableGroupsDropdown";
import { useStyles } from "./styles";

export function Label({
  fieldName,
  isAchievementForm,
}: {
  fieldName: string;
  isAchievementForm?: boolean;
}) {
  const classes = useStyles();
  const { message } = useMessage();
  const { setFieldValue, values } = useFormikContext();
  const value = _.get(values, fieldName);

  const isVariableConditionSelected =
    ["is_one_of_group_values", "is_not_one_of_group_values"].indexOf(
      value.operator,
    ) >= 0;
  return (
    <>
      <Grid
        item
        xs={isVariableConditionSelected ? 12 : 6}
        order={isVariableConditionSelected ? 2 : 0}
      >
        <SelectInput
          className={classes.input}
          data-test-id="condition-operator"
          width="100%"
          items={[
            {
              id: "has_at_least_one_label",
              label: message({ id: "hasAtLeastOneCustomAttribute" }),
            },
            ...(isAchievementForm
              ? []
              : [
                  {
                    id: "is_one_of_group_values",
                    label: message({ id: "is_one_of_collections" }),
                  },
                  {
                    id: "is_not_one_of_group_values",
                    label: message({ id: "is_not_one_of_collections" }),
                  },
                ]),
          ]}
          label={<RequiredFieldLabel text={message({ id: "condition" })} />}
          name={`${fieldName}.operator`}
          onChange={(e) => {
            const isVariableConditionSelected =
              ["is_one_of_group_values", "is_not_one_of_group_values"].indexOf(
                e.target.value,
              ) >= 0;

            return setFieldValue(
              `${fieldName}.data`,
              isVariableConditionSelected ? {} : [],
            );
          }}
        />
      </Grid>
      {["has_at_least_one_label"].indexOf(value.operator) >= 0 && (
        <Grid item xs={12}>
          <MultiWithModal
            maxWidth="unset"
            className={classes.input}
            data-test-id="condition-value"
            formField={`${fieldName}.data`}
            label={<RequiredFieldLabel text={message({ id: "value" })} />}
            placeholder={message({ id: "addCustomAttribute" })}
            maxLength={255}
          />
        </Grid>
      )}

      {isVariableConditionSelected && (
        <>
          <Grid item xs={6} order={1}>
            <TextInput
              width="100%"
              className={classes.input}
              data-test-id="condition-value-attribute-key"
              label={
                <RequiredFieldLabel
                  text={message({ id: "customAttributeKeyLabel" })}
                />
              }
              name={`${fieldName}.data.attributeKey`}
            />
          </Grid>
          <Grid item xs={12} order={2}>
            <VariableGroupsDropdown
              fieldName={`${fieldName}.data.groupOfValues`}
              data-test-id="condition-value"
              placeholder={message({ id: "chooseFromTheList" })}
              value={value.data?.groupOfValues}
            />
          </Grid>
        </>
      )}
    </>
  );
}
